<template>
  <div class="menus-wrap">
    <div>
      <button @click.prevent="addMenu">Add Menu</button>
      <button @click.prevent="saveAllMenus">Save</button>
      <!-- <button @click.prevent="clearAllChanges">Clear All Changes</button> -->
      <button @click.prevent="printMenu">Print Menu</button>
    </div>

    <h1 style="text-align: center;">Our Menus</h1>
    <draggable
      v-if="wpMenus.length"
      v-model="wpMenus"
      class="menus"
      :options="{draggable:'.menu'}" @start="drag=true" @end="drag=false"
    >
      <menu-block
        v-for="menu in wpMenus"
        :menu="menu"
        :key="menu.id"
        :isEditable="menuIsEditable(menu)"
        @singleClick="enableEditMode(menu)"
        @clickAway="disableEditMode(menu)"
        @deleteMenu="deleteMenu"
      />

    </draggable>
  </div>
</template>

<script>

const testAcfData = require('./testAcfData.js')

import _ from 'lodash'
import axios from 'axios'

import { mapState } from 'vuex'
  
import draggable from 'vuedraggable'
import EditableTextField from './EditableTextField'
import MenuBlock from './Menus/MenuBlock'


export default {

  name: 'MenusList',
  components : {
    draggable,
    'menu-block' : MenuBlock,
    'editable-text' : EditableTextField
  },
  props : {
    'postType' : {
      type: String,
      required: false,
      default : 'satsuma_menu_blocks'
    }
  },

  data () {
    return {
      apiResponse : '',
      wpMenus : [],
      newMenus : [],
      menu_order : 0,
      originalData : [],
      authToken : null
    }
  },
  computed: {
    ...mapState(['menus', 'wpData']),
    _() {
      return _;
    }
  },
  mounted() {
    this.getPosts(this.postType);
  },
  methods : {
    menuIsEditable( post ) {
      return post.editable && !post.disabled;
    }, // menuIsEditable()

    toggleEditMode( post ) {
      this.setMenuProp( post, 'editable', !post.editable);
    }, // toggleEditMode

    enableEditMode( post ) {
      this.setMenuProp( post, 'editable', true);
    }, // enableEditMode

    disableEditMode( post ) {
      this.setMenuProp( post, 'editable', false);
    },

    addMenu() {
      let newMenu = {
        id : Date.now(),
        new : true,
        title: {rendered : 'Menu ' + (this.wpMenus.length + 1) },
        editable:true,
        acf : {
          sections : [
            {
              section_title : 'new menu section',
              section_uuid : Date.now() + this.wpMenus.length,
              items : []
            }          
          ]
        }
      };
      this.wpMenus.push( newMenu );

    }, // addMenu

    async getPosts(route = 'posts', namespace = 'wp/v2') {
      try {
        const restURL = this.wpData.rest_url;
        const postsPerPage = 100; // default is 10.
        const fields = 'id,title,vue_meta,acf,menu_order'; // retrieve data for specific fields only.

        const response = await axios(
          `${restURL}/${namespace}/${route}?per_page=${postsPerPage}&page=1&_fields=${fields}`
        );

        this.wpMenus = _.sortBy( response.data, post => { return post.menu_order });

        this.isDataAvailable = true;

        /*
         * calculate total number of required API requests using the header fields from the response.        
         * headers['x-wp-total']: Total WordPress Posts
         * headers['x-wp-totalpages'] Total number of pages based on the per_page param.
         */
        const wpTotalPages = Math.ceil(
          response.headers['x-wp-total'] / postsPerPage
        );        

        // check & get additional posts but restrict to 1000 posts when per_page is 100. Modify this per your needs.
        const promises = [];
        for ( let page = 2; page <= wpTotalPages && 10 >= page; page++ ) {          
          promises.push( // save the promise returned by the axios requests.
            axios( `${restURL}/${namespace}/${route}?per_page=${postsPerPage}&page=${page}&_fields=${fields}` )
        ); }
        // Await all promises to return before rendering the data.         
        const wpData = await Promise.all( promises );

        wpData.map( post => this.wpMenus.push( ...post.data ) );

        this.originalData = _.clone(this.wpMenus); 
        this.$store.commit('setMenus', this.wpMenus);

      }

      catch ( error ) {
        this.apiResponse = ` The request could not be processed! <br> <strong>${error}</strong> `;
      }
    }, // getPosts

    saveAllMenus() {
      this.$notify('Updating..');

      this.$store.dispatch('authPromise').then( authRes => {
        this.authToken = authRes.data.token;        

        let axiosPromises = this.buildPromises();
        
        axios.all(axiosPromises).then( axios.spread( ()=> {
          this.$notify('Done with promises');
        }))

      });


    }, // saveAllMenus()

    buildPromises() {
      let promises = [];

      _.each( this.wpMenus, (post, i) => {
          var axiosCall;
          this.menu_order = i;

          axiosCall = !post.new? this.updateMenuPost( post ) : this.newMenuPost( post );
          promises.push(axiosCall);
      });
      return promises;
    }, // buildPromises

    clearAllChanges() {
      this.wpMenus = this.originalData;
    }, // clearAllChanges

    async printMenu() {
      const browser = await puppeteer.launch();

      const page = await browser.newPage();
      await page.goto('http://clients.madebycaliper.com/satsuma', {waitUntil: 'networkidle2'} );
      let dom = await page.$eval('.menus-wrap', (element) => {
           return element.innerHTML
      }) // Get DOM HTML
  
      const styles = await page.$$eval('link[rel=stylesheet]', (element) => {
        return element;
      }) // Get style tags
      

      let parentFontsHref = await page.$eval('#twentyseventeen-fonts-css', el => el.href);      
      let parentStyleHref = await page.$eval('#parent-style-css', el => el.href);      
       
      console.log('[Stylesheets]')
      console.log(styles)

      await page.setContent(dom)   // HTML markup to assign to the page for generate pdf
      await page.addStyleTag({url:parentFontsHref});
      await page.addStyleTag({url:parentStyleHref});
      await page.addStyleTag({url:'https://fonts.googleapis.com/css?family=Jaldi:400,700'});

      let options = {
        format : 'legal',
        landscape: true,
        path : 'menu.pdf'
      }
      await page.pdf(options)

      await browser.close();
    }, // printMenu

    setMenuProp(post, key, val) {
      let post_id = post.id;

      // Update the menu item by cloning and modifying it,
      // then splicing the wpMenus obj
      let index = _.findIndex(this.wpMenus, function(post) { return post.id == post_id });
      let tmpMenu = _.clone(this.wpMenus[ index ]);
      tmpMenu[ key ] = val;
      this.wpMenus.splice( index, 1, tmpMenu );
      
    }, // setMenuProp

  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Jaldi:400,700');

.menus-wrap {
  // width:80%;
  // max-width:720px;
  margin:auto;
}

ul {
  list-style:none;
  padding:0;
  margin:0;
}

.menus {
  display:flex;
  flex-wrap:wrap;
}

button {
  cursor:pointer;
  transition: background-color .3s ease;  
  background-color:#34bd34;
  border:0;
  color:white;
  font-size:0.7rem;
  padding:7px 10px;
  text-transform:uppercase;
  // position:absolute;
  // transform:translateX(-110%);

  &:hover {
    background-color:#319831;    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenusList.vue